/* The footer takes its ground from whatever section ends the page, so the page
 * finishes on one continuous surface instead of butting a fixed footer colour
 * against whichever section happens to sit above it.
 *
 * Every wh-* section paints its ground on its own first element child (the
 * .shopify-section wrapper stays transparent), so that is where we look first.
 */
(function () {
  var PARSE = /^rgba?\(([^)]+)\)$/;

  /* A colour only counts if it actually covers what is behind it. */
  function opaqueRgb(el) {
    if (!el) return null;
    var match = PARSE.exec(getComputedStyle(el).backgroundColor || '');
    if (!match) return null;
    var parts = match[1].split(',').map(parseFloat);
    if (parts.length < 3 || parts.some(isNaN)) return null;
    if (parts.length > 3 && parts[3] < 0.95) return null;
    return parts.slice(0, 3);
  }

  function groundOfLastSection(main) {
    var sections = main.querySelectorAll(':scope > .shopify-section');
    for (var i = sections.length - 1; i >= 0; i--) {
      var section = sections[i];
      if (!section.offsetHeight) continue; // skip anything not actually rendered
      return opaqueRgb(section.firstElementChild) || opaqueRgb(section);
    }
    return null;
  }

  /* WCAG relative luminance, so the footer's text flips on a dark ground. */
  function luminance(rgb) {
    var channels = rgb.map(function (value) {
      var v = value / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
  }

  function apply() {
    var footer = document.querySelector('.footer');
    var main = document.getElementById('MainContent');
    if (!footer || !main) return;

    var rgb = groundOfLastSection(main);
    if (!rgb) return; // leave the stylesheet's own colour in place

    footer.style.setProperty('--wh-footer-paper', 'rgb(' + rgb.join(', ') + ')');
    footer.classList.toggle('footer--on-dark', luminance(rgb) < 0.45);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
